import type { AuthState } from "@tg/shared";

interface AuthDraft {
  phoneNumber: string;
  code: string;
  password: string;
  firstName: string;
  lastName: string;
}

const authDraftStore = new Map<string, AuthDraft>();

const createEmptyDraft = (): AuthDraft => ({
  phoneNumber: "",
  code: "",
  password: "",
  firstName: "Telegram",
  lastName: ""
});

export const isSameAuthState = (
  left: AuthState | null | undefined,
  right: AuthState | null | undefined
): boolean => {
  if (!left || !right) {
    return left === right;
  }

  return (
    left.accountId === right.accountId &&
    left.step === right.step &&
    left.updatedAt === right.updatedAt &&
    left.isAuthorized === right.isAuthorized &&
    left.error === right.error &&
    left.hint === right.hint &&
    left.link === right.link
  );
};

export const normalizePhoneNumberForSubmit = (value: string): string => {
  const trimmed = value.trim();
  if (trimmed.length === 0) {
    return "";
  }

  const hasPlusPrefix = trimmed.startsWith("+");
  const digits = trimmed.replace(/\D/g, "");
  if (digits.length === 0) {
    return "";
  }

  if (hasPlusPrefix) {
    return `+${digits}`;
  }

  if (digits.startsWith("00") && digits.length > 2) {
    return `+${digits.slice(2)}`;
  }

  if (digits.length === 11 && digits.startsWith("8")) {
    return `+7${digits.slice(1)}`;
  }

  if (digits.length === 11 && digits.startsWith("7")) {
    return `+${digits}`;
  }

  if (digits.length === 10) {
    return `+7${digits}`;
  }

  return `+${digits}`;
};

export const readAuthDraft = (accountId: string): AuthDraft => {
  const existing = authDraftStore.get(accountId);
  return existing ? { ...existing } : createEmptyDraft();
};

export const patchAuthDraft = (
  accountId: string,
  patch: Partial<AuthDraft>
): AuthDraft => {
  const next = {
    ...readAuthDraft(accountId),
    ...patch
  };
  authDraftStore.set(accountId, next);
  return { ...next };
};

export const clearAuthDraft = (accountId: string): void => {
  authDraftStore.delete(accountId);
};
